import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d09b1e36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 1,
  class: "left"
}
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { class: "text-container" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = {
  key: 0,
  class: "subtext"
}
const _hoisted_8 = ["onClick"]

import ProfileAvatar from "@/components/images/ProfileAvatar.vue";
import { IListItem, ListItemTypeEnum } from "../../../types/list";
import { withDefaults } from "vue";
import { useI18n } from "vue-i18n";
import { useGetListItemsSelectProperties } from "./useGetListItemsSelectProperties";
import { getIconName } from "./getIconName";
import { IconType } from "@/types/icons";
import Icon from "@/components/icons/Icon/Icon.vue";

interface Props {
  listItemsArray: IListItem[];
}

interface ListItemsSelectEmits {
  (e: "add-member", member: IListItem): void;
  (e: "remove-member", member: IListItem): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ListItemsSelect',
  props: {
    listItemsArray: { default: () => [] }
  },
  emits: ["add-member", "remove-member"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;
const { t } = useI18n();

const {
  visibleListItemsArray,
  handleClick,
  getTextAppliedClassesObject,
  getAppliedText,
  getAppliedSubtext,
  handleInviteToApp,
  getIsTextBold,
} = useGetListItemsSelectProperties(props, emit);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleListItemsArray), (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.itemId,
        class: _normalizeClass(["item", _unref(getTextAppliedClassesObject)(item)]),
        onClick: ($event: any) => (_unref(handleClick)(item))
      }, [
        (
          (item.type === _unref(ListItemTypeEnum).Chat && item.pictureSrc) ||
          item.isPictureDisplayed
        )
          ? (_openBlock(), _createBlock(ProfileAvatar, {
              key: 0,
              src: item.pictureSrc,
              "is-online": item.isOnline
            }, null, 8, ["src", "is-online"]))
          : (item.iconName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(Icon, {
                  icon: item.iconName
                }, null, 8, ["icon"])
              ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(getAppliedText)(item)), 1),
            (item.subtext)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(getAppliedSubtext)(item)), 1))
              : _createCommentVNode("", true)
          ]),
          (item.type === _unref(ListItemTypeEnum).Link)
            ? (_openBlock(), _createBlock(Icon, {
                key: 0,
                icon: _unref(getIconName)(item.textColorType)
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          (item.type === _unref(ListItemTypeEnum).Checkmark)
            ? (_openBlock(), _createBlock(Icon, {
                key: 1,
                icon: _unref(IconType).CHECKBOX_OFF,
                class: "checkbox-img"
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          (item.type === _unref(ListItemTypeEnum).Checkmarked)
            ? (_openBlock(), _createBlock(Icon, {
                key: 2,
                icon: _unref(IconType).CHECKBOX_ON,
                class: "checkbox-img"
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          (item.type === _unref(ListItemTypeEnum).CheckmarkedDisabled)
            ? (_openBlock(), _createBlock(Icon, {
                key: 3,
                icon: _unref(IconType).CHECKBOX_ON_GRAY,
                class: "checkbox-img"
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          (item.type === _unref(ListItemTypeEnum).Lang && _unref(getIsTextBold)(item))
            ? (_openBlock(), _createBlock(Icon, {
                key: 4,
                icon: _unref(IconType).CHECKMARK
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          (item.type === _unref(ListItemTypeEnum).Chat && item.isNotInvited)
            ? (_openBlock(), _createElementBlock("p", {
                key: 5,
                class: "isNotInvited",
                onClick: ($event: any) => (_unref(handleInviteToApp)(item))
              }, _toDisplayString(_unref(t)("select.invite")), 9, _hoisted_8))
            : _createCommentVNode("", true)
        ])
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})